module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/title-df0579e0419f510883cfbd8e5fc1afc1.png";